<template>
  <div class="blacklist-customer-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><svg-icon icon-class="blacklist" /> Customer Blacklist </span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="createCustomBlacklist"
          ><i class="el-icon-plus"></i> Add Blacklist</el-button
        >
      </div>
      <div>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column label="Member Code" prop="memberCode" width="120" align="center">
            </el-table-column>
            <el-table-column label="Name" prop="name" min-width="200">
            </el-table-column>
            <el-table-column
              label="Exactly Match"
              prop="exactlyMatch"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag :type="`${!scope.row.exactlyMatch ? 'info' : ''}`">
                  {{ scope.row.exactlyMatch ? "Yes" : "No" }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              label="Action"
              prop="uid"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="warning"
                  size="mini"
                  @click="editBlacklist(scope.row.uid, scope.row.plusuid)"
                >
                  Edit
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteBlacklist(scope.row.uid, scope.row.plusuid, scope.row.name)"
                >
                  Del
                </el-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
    </el-card>

        <el-dialog
      :title="titleDialog"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="formDataRules"
        label-width="120px"
        size="mini"
        
      >

        <el-form-item label="Name" prop="name">
          <el-input v-model="formData.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Exactly Match">
          <el-select v-model="formData.exactlyMatch">
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitBlacklist" :loading="submitting"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchCustomBlacklist,
  getCustomBlacklist,
  getCustomProjectBlacklist,
  createCustomBlacklist,
  getCustomBlacklistByUID,
  putCustomBlacklistByUID,
  deleteCustomBlacklistByUID,
} from "@/api/firewall-blacklist";
export default {
  props:{
    plusUID: String
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      actionDialog: "add",
      enterTimeout: null,
      editUID: "",
      titleDialog: "Create Custom Blacklist",
      
      tableData: [],
      formData: {
        name: "",
        exactlyMatch: false,
      },
      formDataRules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
      },
      query: {
        start: 0,
        length: this.pageSize,
        order: "DESC"
      },
      recordTotal: 0,
      pageSize: 10,
      currentPage: 1
    };
  },
  methods:{
    getCustomBlacklist(){
      this.loading = true;
      getCustomBlacklist(this.plusUID).then(({result, data})=>{
        this.loading = false;
        if(result){
          this.tableData = data
           
        }
      })
    },
    createCustomBlacklist() {
      this.resetForm();
      this.dialogFormVisible = true;
      this.actionDialog = "add";
      this.titleDialog = "Create Custom Blacklist";
    },
    submitBlacklist() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (this.actionDialog === "add") {
            createCustomBlacklist(this.plusUID, this.formData).then(({ result, message }) => {
              this.submitting = false;
              if (result) {
                this.dialogFormVisible = false;
                this.getCustomBlacklist();
                this.resetForm();
              } else {
                this.$message.error(message);
              }
            });
          } else {
            putCustomBlacklistByUID(this.plusUID, this.editUID, this.formData).then(
              ({ result, message }) => {
                this.submitting = false;
                if (result) {
                  this.dialogFormVisible = false;
                  this.editUID = "";
                  this.getCustomBlacklist();
                  this.resetForm();
                } else {
                  this.$message.error(message);
                }
              }
            );
          }
        }
      });
    },
    editBlacklist(uid, plusuid) {
      this.loading = true;
      this.editUID = uid;
      this.titleDialog = "Edit Custom Blacklist";
      getCustomBlacklistByUID(plusuid, uid).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.formData.name = data.name;
          this.formData.exactlyMatch = data.exactlyMatch ? true : false;
          this.actionDialog = "edit";
          this.dialogFormVisible = true;
        }
      });
    },
    deleteBlacklist(uid, plusuid, name) {
      this.$confirm(`This will delete ${name} . Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          deleteCustomBlacklistByUID(plusuid, uid).then(({ result, message }) => {
            this.loading = false;
            if (result) {
              this.getCustomBlacklist();
            } else {
              this.$message.error(message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    resetForm() {
      this.formData.name = "";
      this.formData.exactlyMatch = false;
      this.editUID = ""
    },
  },
  mounted(){
    setTimeout(()=>{
      this.getCustomBlacklist()
    }, 1000)
  }
}
</script>

<style>

</style>